export default "__VITE_ASSET__BRP_lvIn__"